<template>
  <!-- preview call progress -->
  <Transition>
    <div class="modal-call">
      <b-modal v-model="showModalMaximizeCall" @hide="onHide"
        centered
        hide-footer
        size="sm"
        header-bg-variant="dark"
        header-text-variant="light"
        body-bg-variant="dark"
        body-text-variant="light"
        footer-bg-variant="dark"
        footer-text-variant="light"
        :static="true"
        :hide-header="true"
        :hide-header-close="true"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        modal-class="modal-call"
        >
        <div class="align-items-center border-header-call mt-1 pt-2 px-3">
          <div class="flex-container-call">
            <div class="text-center">
              <p class="h5 font-weight-bold"> {{ phone_call.status }}</p>
            </div>
            <h5 v-if="call.duration !== 0">{{ call.duration }}</h5>
            <a v-if="showVideo" class="text-light cursor-pointer mb-2" @click="minimizeCall()">
              <i class="mdi mdi-arrow-collapse mdi-18px"></i>
            </a>
          </div>
        </div>
        <div>
          <div>
            <div v-if="isEnableVideoCallFeature" class="mt-2">
              <div class="video-focus">
                <div class="d-flex my-1 px-2 py-1 call-details justify-content-between">
                  <div>
                    <h5>{{ isChatPrivacy(phone_call.name) }}</h5>
                    <p>{{ isChatPrivacy(phone_call.phone_number) }}</p>
                  </div>
                </div>
                <div v-show="showVideo && call_session?.call_type === 'video_call'" class="miniVideo">
                  <video ref="miniVideo" autoplay playsinline muted></video>
                </div>
                <div class="icon-video" v-show="showVideo && call_session?.call_type !== 'video_call'">
                  <i class="mdi mdi-video-off mdi-100px"></i>
                </div>
                <video class="focusVideo" ref="focusVideo" autoplay playsinline muted></video>
              </div>
            </div>
            <div v-else class="d-block text-center mt-4">
              <div class="rounded-full" v-html="this.identicons(phone_call.conversation_id)"/>
              <h5 class="mt-3">{{ isChatPrivacy(phone_call.name) }}</h5>
              <p>{{ isChatPrivacy(phone_call.phone_number) }}</p>
              <h5 class="mt-2" v-if="call.duration !== 0">{{ call.duration }}</h5>
            </div>
            <!-- Maricall IVR screen-pop: what the customer chose before reaching the agent -->
            <div v-if="ivrScreenPop" class="mx-3 mb-3 px-3 py-2 rounded text-left ivr-screen-pop">
              <p class="mb-1 text-secondary ivr-screen-pop-label">IVR SELECTION</p>
              <p class="mb-1" v-if="ivrScreenPop.flow_name"><i class="mdi mdi-sitemap mr-1"></i>{{ ivrScreenPop.flow_name }}</p>
              <p class="mb-1 font-weight-bold" v-if="ivrScreenPop.choice"><i class="mdi mdi-gesture-tap mr-1"></i>{{ ivrScreenPop.choice }}</p>
              <p class="mb-0 text-secondary" v-if="ivrScreenPop.dtmf">Pressed: {{ ivrScreenPop.dtmf }}</p>
            </div>
            <!-- <div class="mb-4 text-center" style="margin-top: 8rem !important" -->
            <div class="mb-4 text-center" style="margin-top: 1.2rem !important" v-if="this.call_session.originator === 'local' || call.duration != 0">
              <el-button circle class="btn btn-secondary btn-icon" @click="showMessagesCardNotes">
                <i class="mdi mdi-note-text mdi-23px"></i>
              </el-button>
              <el-button circle class="btn btn-secondary btn-icon" @click="handleMicPhoneCall">
                <i :class="phone_call.mic"></i>
              </el-button>
              <!-- <el-button v-if="isEnableVideoCallFeature" circle class="btn btn-secondary btn-icon" @click="handleCamPhoneCall">
                <i :class="phone_call.video"></i>
              </el-button> -->
              <el-button circle class="btn btn-danger btn-icon" @click="handleEndPhoneCall">
                <i class="mdi mdi-phone-hangup mdi-23px"></i>
              </el-button>
            </div>
            <div class="mb-4 text-center" style="margin-top: 1.2rem !important" v-else>
              <el-button circle class="btn btn-danger btn-icon" @click="handleEndPhoneCall">
                <i class="mdi mdi-phone-hangup mdi-23px"></i>
              </el-button>
              <el-button circle class="btn btn-success btn-icon" @click="handleAnswerIncomingCall"
                v-if="this.call_session.originator === 'remote'" >
                <i class="mdi mdi-phone mdi-23px"></i>
              </el-button>
            </div>
          </div>
          <div v-if="showCardNotes" class="px-3 mb-3">
            <hr />
            <h4 class="mb-3">Notes Call</h4>
            <div>
              <textarea
                id="notes"
                @input="handleChangeNotesContent"
                :value="notes.content"
                :maxlength="notes.maximumLength"
                rows="11"
                cols="37"
                class="w-full p-2 rounded text-light bg-dark"
                style="border: 1px solid rgba(255, 255, 255, 0.15);"
                placeholder="Write notes about this call here..."
              ></textarea>
              <div class="text-right text-secondary mt-1 text-sm">
                {{ notes.content.length }} / {{ notes.maximumLength }}
              </div>
            </div>
            <div class="w-100 d-flex justify-content-end mt-3 pb-2">
              <el-button class="btn btn-outline-primary" size="small" @click="showCardNotes = false">Close</el-button>
              <el-button @click="handleSaveNotes" type="primary" size="small">Save</el-button>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </Transition>
</template>

<script>
// import moment from 'moment';
// import _ from 'lodash';
// import openSocket from 'socket.io-client';
// import JsSIP from 'jssip';
import { toSvg } from 'jdenticon';
// import NotifSound from '../../../assets/sound/Block.mp3';
// import config from '@/config';
// import conversationsAPI from '../../../api/conversations';
// import popupErrorMessages from '../../../library/popup-error-messages';

// const socket = openSocket(config.api.chatUrl, {
//   transports: ['websocket'],
//   upgrade: false,
//   reconnection: true,
//   reconnectionAttempts: 1000,
//   reconnectionDelay: 1000,
// });
// prox-quiros.mariworks.id
// process.env.VUE_APP_SIP_DOMAIN
// const connect_sip = new JsSIP.WebSocketInterface('wss://process.env.VUE_APP_SIP_DOMAIN:8089/ws');
// // connect_sip.via_transport = 'tcp';
// const configuration = {
//   sockets: [connect_sip],
//   uri: 'sip:4007@process.env.VUE_APP_SIP_DOMAIN',
//   password: 'WAPPIN2024',
//   display_name: 'Agent AAA',
//   pcConfig: {
//     rtcpMuxPolicy: 'negotiate',
//     iceServers: [{
//       urls: [
//         'stun:stun.l.google.com:19302',
//       ],
//     }],
//   },
// };
// const socket_sip = new JsSIP.UA(configuration);

export default {
  name: 'PreviewMaximizeCall',
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    call_session: {
      type: Object,
      default() {
        return {};
      },
    },
    phone_call: {
      type: Object,
      default() {
        return {};
      },
    },
    call: {
      type: Object,
      default() {
        return {};
      },
    },
    notes: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      showModalMaximizeCall: false,
      showCardNotes: false,
      showVideo: false,
    };
  },
  computed: {
    activeWorkspace() {
      return this.$store.state.workspace.activeWorkspace || {};
    },
    isEnableVideoCallFeature() {
      return this.activeWorkspace.products && this.activeWorkspace.products[0].pricing.whatsapp.enable_video_call_feature;
    },
    // Maricall IVR screen-pop (WAP-358 / PD-D.4). chat-api resolves the Maricall
    // node UUIDs to human labels (selected_label/path_labels) before pushing this
    // over socket, so the browser never needs the IVR flow map. Defensive: render
    // nothing when there is no IVR context (direct-to-queue) or nothing readable.
    ivrScreenPop() {
      const ctx = this.phone_call && this.phone_call.ivr_context;
      if (!ctx) return null;
      const dtmf = Array.isArray(ctx.dtmf_inputs) ? ctx.dtmf_inputs.filter((d) => d || d === 0) : [];
      const choice = ctx.selected_label
        || (Array.isArray(ctx.path_labels) && ctx.path_labels.length ? ctx.path_labels[ctx.path_labels.length - 1] : '')
        || '';
      if (!choice && !dtmf.length && !ctx.flow_name) return null;
      return { flow_name: ctx.flow_name || '', choice, dtmf: dtmf.join(' ') };
    },
  },
  methods: {
    identicons(value) {
      return toSvg(value, '75');
    },
    onHide() {
      this.$emit('onHide');
    },
    handleMicPhoneCall() {
      // this.isMutedCall = !this.isMutedCall;
      // this.phone_call.mic = this.isMutedCall ? 'mdi mdi-microphone-off mdi-23px' : 'mdi mdi-microphone mdi-23px';
      this.$emit('handleMicPhoneCall');
    },
    handleCamPhoneCall() {
      // this.isOffCam = !this.isOffCam;
      // this.phone_call.video = this.isOffCam ? 'mdi mdi-video-off mdi-23px' : 'mdi mdi-video mdi-23px';
      this.$emit('handleCamPhoneCall');
      // const session_muted = this.call_session.session.isMuted();
      // if (session_muted.video) {
      //   this.phone_call.video = 'mdi mdi-video mdi-23px';
      //   this.call_session.session.mute({
      //     audio: session_muted.audio,
      //     video: true,
      //   });
      // } else {
      //   this.phone_call.video = 'mdi mdi-video-off mdi-23px';
      //   this.call_session.session.unmute({
      //     audio: session_muted.audio,
      //     video: false,
      //   });
      // }
    },
    handleVolumePhoneCall() {
      if (this.phone_call.volume === 'mdi mdi-volume-low mdi-23px') {
        this.phone_call.volume = 'mdi mdi-volume-source mdi-23px';
      } else {
        this.phone_call.volume = 'mdi mdi-volume-low mdi-23px';
      }
    },
    handleAnswerIncomingCall() {
      this.$parent.handleAnswerIncomingCall();
    },
    handleEndPhoneCall() {
      this.$parent.handleEndPhoneCall();
    },
    minimizeCall() {
      this.$parent.handleMinimizePhoneCall();
    },
    showMessagesCardNotes() {
      this.showCardNotes = !this.showCardNotes;
    },
    handleChangeNotesContent(e) {
      this.$emit('update:notes', {
        ...this.notes,
        content: e.target.value,
      });
    },
    handleSaveNotes() {
      this.$parent.saveNotes();
    },
    isChatPrivacy(number) {
      let phone_number = number;
      if (phone_number && this.$store.state.auth.userProfile.is_pic !== true && this.$store.state.auth.userProfile.agents && this.$store.state.auth.userProfile.agents[0] && this.activeWorkspace.configuration && this.activeWorkspace.configuration.chat_privasi && this.activeWorkspace.configuration.chat_privasi.masking_phone_number === true) {
        if (number.charAt(0) === '0') {
          phone_number = number.replace('0', '62');
        }
        const validateRegex = /^\+?[1-9][0-9]{4,14}$/;
        if (validateRegex.test(`${phone_number}`)) {
          return `${phone_number.substring(0, 2)}********${phone_number.substring(phone_number.length - 2)}`;
        }
      }
      return phone_number;
    },
  },
  watch: {
    show() {
      this.showModalMaximizeCall = this.show;
    },
  },
};
</script>

<style>
.modal-call .bg-dark {
  background-color: #101623 !important;
}
.modal-call .modal-content {
  border: 1px solid #474747;
  background-color: #101623;
  border-radius: 1.135rem;
}
.modal-header {
  /* border-bottom: 1px solid #474747; */
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.modal-body {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;
}
.modal-call .modal-body {
  padding: 0 !important;
}
/* .border-header-call {
  border-bottom: 2px solid #474747 !important;
} */
.btn.btn-icon {
  width: 35px !important;
  height: 35px !important;
}

.call-details {
  position: absolute;
  top: 10px;
  left: 7px;
  z-index: 1000;
  background-color: #a4a4a4;
  border-radius: 5px;
}
.flex-container-call {
  display: flex;
  /* align-content: space-between; */
  align-items: baseline;
  justify-content: space-between;
  margin-inline-end: auto;
}
.video-focus {
  flex-grow: 1;
  width: 100%;
  height: auto;
  max-height: 100%;
  background: black;
  border-radius: 10px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.video-focus .focusVideo {
  /* width: 100%;
  height: 100%; */
  width: 100%;
  border-radius: 2px;
  /* height: auto; */
  object-fit: cover;
  height: 500px;
}
.video-focus .miniVideo {
  flex-grow: 1;
  width: 50%;
  height: auto;
  max-height: 250%;
  background: black;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 7px;
  left: 7px;
}
.video-focus .miniVideo video {
  width: 100%;
  border-radius: 5px;
  height: 100px;
  object-fit: cover;
  /* position: absolute; */
}
.video-focus .icon-video {
  position: absolute;
  left: 125px;
}
.ivr-screen-pop {
  background-color: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
}
.ivr-screen-pop-label {
  font-size: 11px;
  letter-spacing: 0.04em;
}
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.mirrored {
  transform: scaleX(-1);
  -webkit-transform: scaleX(-1);
}
</style>
